import { useState } from 'react';
import Modal from '../modal/Modal';
import { useModal } from '../modal/useModal';
import { showErrorNotification, showSuccessNotification } from '../../util/notifications';
import useApi from '../../api';
import classNames from 'classnames';
import { useQueryClient } from 'react-query';
import { QueryKey } from '../../constants/queryKey';
import RoleSelector from './RoleSelector';

const CreateUserModal = ({ modalId }) => {
    const { closeModal } = useModal();
    const [isLoading, setIsLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');
    const [role, setRole] = useState('viewer');
    const { createUser } = useApi();
    const queryClient = useQueryClient();

    const buttonClass = classNames('button', {
        'button--loading': isLoading,
    });

    const onSubmit = async (e) => {
        e.preventDefault();
        setEmailError('');
        if (!email.trim()) {
            setEmailError('Email is required');
            return;
        }
        if (!/\S+@\S+\.\S+/.test(email.trim())) {
            setEmailError('Enter a valid email address');
            return;
        }

        setIsLoading(true);
        try {
            await createUser({ email: email.trim(), role });
            await queryClient.invalidateQueries(QueryKey.Users);
            showSuccessNotification('User created. They can set a password via the login page.');
            closeModal(modalId);
        } catch (err) {
            const msg = err.response?.data?.error || 'Something went wrong creating the user.';
            showErrorNotification(msg);
        }
        setIsLoading(false);
    };

    return (
        <Modal modalId={modalId}>
            <h1 className="modal__title">Add user</h1>
            <form onSubmit={onSubmit} noValidate className="form">
                <div className="form__group">
                    <label className="form__label">Email <span style={{ color: '#ff4d59' }}>*</span></label>
                    <div className="form__field">
                        <input
                            className="form_field--text"
                            type="email"
                            value={email}
                            onChange={(e) => { setEmail(e.target.value); setEmailError(''); }}
                            placeholder="user@example.com"
                        />
                    </div>
                    {emailError && <div className="form__error">{emailError}</div>}
                </div>
                <div className="form__group">
                    <label className="form__label">Role</label>
                    <RoleSelector value={role} onChange={setRole} />
                </div>
                <div className="modal__footer">
                    <button type="button" className="button button--link" onClick={() => closeModal(modalId)}>Cancel</button>
                    <button type="submit" className={buttonClass}>Create</button>
                </div>
            </form>
        </Modal>
    );
};

export default CreateUserModal;
